module.exports = __webpack_public_path__ + "static/media/smdc.ec1587d1.png";